// Widget Studio — installations list page (CHG-2463 / ITER-905205, S4).
//
// Thin wrapper: config in @generated/screens/widget-installation-list,
// regenerated from widget-installation.entity-hint.yaml. Standalone surface at
// /channels/widgets/installations (also surfaced as a tab on the instance
// detail). Reached via the instance-detail Installations tab + row links.

import { ListPage } from "../components/composition";
import { widgetInstallationListConfig } from "../generated/screens/widget-installation-list";

export function WidgetInstallations() {
  return <ListPage config={widgetInstallationListConfig} />;
}
